export class AddressValidationSemaphore {
    private locked: boolean = false;

    async acquire(): Promise<void> {
        while (this.locked) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        this.locked = true;
    }

    release(): void {
        this.locked = false;
    }
}

export const addressValidationSemaphore = new AddressValidationSemaphore();
